module.exports = __webpack_public_path__ + "static/media/25.cde9a55e.mp3";